import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getPublicMenuPath } from '@/lib/tenant/getPublicMenuPath';

/** Entrada del menú público: catálogo directo (portada opcional más adelante). */
export default function MenuWelcomeRedirect() {
  const { businessId } = useParams();
  const routeBid = String(businessId ?? '').trim();
  return <Navigate to={getPublicMenuPath(routeBid, 'home')} replace />;
}
